Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyPropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = require('airbnb-prop-types');

var _direction = require('react-with-direction/dist/proptypes/direction');

var _direction2 = _interopRequireDefault(_direction);

var _withStyles = require('../themes/withStyles');

var _Shimmer = require('../exp/Shimmer');

var _Shimmer2 = _interopRequireDefault(_Shimmer);

var _withLoading = require('../exp/withLoading');

var _withLoading2 = _interopRequireDefault(_withLoading);

var _idProp = require('../utils/propTypes/idProp');

var _idProp2 = _interopRequireDefault(_idProp);

var _requiredUnless = require('../utils/propTypes/requiredUnless');

var _requiredUnless2 = _interopRequireDefault(_requiredUnless);

var _textAlignPosition = require('../constants/textAlignPosition');

var _typographyConstants = require('../constants/typographyConstants');

var _conditionallyRestrictedProp = require('../utils/propTypes/conditionallyRestrictedProp');

var _conditionallyRestrictedProp2 = _interopRequireDefault(_conditionallyRestrictedProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var noInlineWithTextAlign = (0, _conditionallyRestrictedProp2['default'])({
  propType: _propTypes2['default'].bool,
  restrictedCondition: function () {
    function restrictedCondition(_ref) {
      var inline = _ref.inline,
          textAlign = _ref.textAlign;
      return !!textAlign && inline;
    }

    return restrictedCondition;
  }(),
  restrictedMessage: function () {
    function restrictedMessage(props, propName, componentName) {
      return String(componentName) + ': ' + String(propName) + ' is forbidden to be true when textAlign is set';
    }

    return restrictedMessage;
  }()
});

var noTextAlignWithInline = (0, _conditionallyRestrictedProp2['default'])({
  propType: _textAlignPosition.textAlignPositionProp,
  restrictedCondition: function () {
    function restrictedCondition(_ref2) {
      var inline = _ref2.inline;
      return inline;
    }

    return restrictedCondition;
  }(),
  restrictedMessage: function () {
    function restrictedMessage(props, propName, componentName) {
      return String(componentName) + ': ' + String(propName) + ' is forbidden for inline text';
    }

    return restrictedMessage;
  }()
});

var typographyPropTypes = exports.typographyPropTypes = {
  id: _idProp2['default'],
  color: _typographyConstants.colorPropType,
  dir: _direction2['default'], // use the `getTextDirection` util to set this prop
  inline: noInlineWithTextAlign,
  textAlign: noTextAlignWithInline,
  lineClamp: _airbnbPropTypes.nonNegativeInteger,
  htmlTitle: (0, _airbnbPropTypes.requiredBy)('lineClamp', _propTypes2['default'].string),
  leading: _typographyConstants.leadingPropType,
  weight: _typographyConstants.weightPropType,
  allCaps: _propTypes2['default'].bool
};

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withLoading.withLoadingPropTypes, _withStyles.withStylesPropTypes, typographyPropTypes, {
  id: _idProp2['default'],
  children: (0, _requiredUnless2['default'])('isLoading', _propTypes2['default'].node),
  size: _typographyConstants.sizePropType
}));

var defaultProps = {
  allCaps: false,
  htmlTitle: null,
  inline: false,
  leading: _typographyConstants.LEADING.DEFAULT,
  color: _typographyConstants.COLOR.DEFAULT,
  size: _typographyConstants.SIZE.REGULAR,
  lineClamp: null,
  weight: _typographyConstants.WEIGHT.DEFAULT
};

function getTag(inline) {
  if (inline) {
    return 'span';
  }

  return 'div';
}

function NewText(_ref3) {
  var allCaps = _ref3.allCaps,
      children = _ref3.children,
      css = _ref3.css,
      dir = _ref3.dir,
      htmlTitle = _ref3.htmlTitle,
      isLoading = _ref3.isLoading,
      inline = _ref3.inline,
      id = _ref3.id,
      styles = _ref3.styles,
      color = _ref3.color,
      size = _ref3.size,
      weight = _ref3.weight,
      leading = _ref3.leading,
      textAlign = _ref3.textAlign,
      lineClamp = _ref3.lineClamp,
      typography = _ref3.theme.__typography;

  var Tag = getTag(inline);
  var singleLineClamp = lineClamp === 1;
  var multiLineClamp = lineClamp > 1;

  return _react2['default'].createElement(
    Tag,
    _extends({
      dir: dir,
      id: id
    }, css(styles.text, styles['size_' + String(size)], styles['weight_' + String(size) + '_' + String(weight)], styles['leading_' + String(size) + '_' + String(leading)], styles['tracking_' + String(size) + '_default'], styles['color_' + String(color)], textAlign && styles['align_' + String(textAlign)], (allCaps || size === 'micro') && styles.allCaps, !!lineClamp && styles.lineClamp, singleLineClamp && styles.lineClamp_single, multiLineClamp && styles.lineClamp_multiple, multiLineClamp && {
      maxHeight: typography.leading[leading] / typography.size[size] * lineClamp + 'em',
      WebkitLineClamp: lineClamp
    }), {
      title: isLoading ? null : htmlTitle
    }),
    isLoading ? _react2['default'].createElement(_Shimmer2['default'], null) : children
  );
}

NewText.componentCategory = 'Private';
NewText.displayName = 'NewText';
NewText.propTypes = propTypes;
NewText.defaultProps = defaultProps;

function getTypographyStyles(typography) {
  var styleObject = {};

  var sizes = Object.keys(typography.size);
  var weights = Object.keys(typography.weight);
  var leadings = Object.keys(typography.leading);
  var trackings = Object.keys(typography.tracking);

  sizes.forEach(function (size) {
    var fontSize = typography.size[size];
    styleObject['size_' + String(size)] = { fontSize: fontSize };

    weights.forEach(function (weight) {
      styleObject['weight_' + String(size) + '_' + String(weight)] = {
        fontWeight: typography.weight[weight][size]
      };
    });

    leadings.forEach(function (leading) {
      styleObject['leading_' + String(size) + '_' + String(leading)] = {
        lineHeight: typography.leading[leading][size] / fontSize
      };
    });

    trackings.forEach(function (tracking) {
      styleObject['tracking_' + String(size) + '_' + String(tracking)] = {
        letterSpacing: typography.tracking[tracking][size] / fontSize + 'em'
      };
    });
  });

  return styleObject;
}

function getColorStyles(color) {
  return {
    color_default: {
      color: color.textDark
    },
    color_inverse: {
      color: color.textLight
    },
    color_muted: {
      color: color.textMuted
    },
    color_inherit: {
      color: 'inherit'
    }
  };
}

function getAlignmentStyles() {
  return {
    align_start: {
      textAlign: 'left'
    },

    align_center: {
      textAlign: 'center'
    },

    align_end: {
      textAlign: 'right'
    },

    align_justify: {
      textAlign: 'justify'
    }
  };
}

exports['default'] = (0, _withLoading2['default'])((0, _withStyles.withStyles)(function (_ref4) {
  var color = _ref4.color,
      typography = _ref4.__typography;
  return Object.assign({}, getTypographyStyles(typography), getColorStyles(color), getAlignmentStyles(), {
    text: {
      fontFamily: typography.fontFamily,

      // Override text margins defined by O2 or Bootstrap
      margin: 0,
      wordWrap: 'break-word'
    },

    allCaps: {
      textTransform: 'uppercase'
    },

    lineClamp: {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },

    lineClamp_single: {
      whiteSpace: 'nowrap'
    },

    lineClamp_multiple: {
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical'
    }
  });
}, { pureComponent: true })(NewText));


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/private/NewText.js
// module id = 431
// module chunks = 168707334958949